import { useContent } from "@/lib/useContent";
import Navbar from "@/components/landing/Navbar";
import Footer from "@/components/landing/Footer";
import { Reveal } from "@/components/landing/Reveal";

export default function LegalPage({ kind, title, subtitle }) {
  const content = useContent();

  if (!content) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#FAF9F5]" data-testid={`${kind}-page-loader`}>
        <span className="font-mono text-xs uppercase tracking-[0.3em] text-[#8896AB]">loading</span>
      </div>
    );
  }

  const sections = content.pages?.[kind] || [];

  return (
    <div className="min-h-screen bg-[#FAF9F5] text-[#0F1B2B]" data-testid={`${kind}-page`}>
      <Navbar brand={content.brand} />
      <section className="relative overflow-hidden pt-36 pb-14 lg:pt-44">
        <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(rgba(15,27,43,0.045)_1px,transparent_1px),linear-gradient(90deg,rgba(15,27,43,0.045)_1px,transparent_1px)] bg-[size:72px_72px] [mask-image:radial-gradient(ellipse_at_top,black_30%,transparent_75%)]" />
        <div className="relative mx-auto max-w-4xl px-5 lg:px-8">
          <Reveal>
            <div className="mb-4 flex items-center gap-3">
              <span className="font-mono text-xs text-[#B8860B]">{"\u00a7"}</span>
              <span className="h-px w-10 bg-[#B8860B]/40" />
              <span className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-[#0E8A8A]">Legal</span>
            </div>
          </Reveal>
          <Reveal delay={0.08}>
            <h1 className="font-syne text-4xl font-bold tracking-tight text-[#0F1B2B] sm:text-5xl" data-testid={`${kind}-title`}>{title}</h1>
          </Reveal>
          {subtitle && (
            <Reveal delay={0.14}>
              <p className="mt-4 text-base text-[#5A6578]">{subtitle}</p>
            </Reveal>
          )}
        </div>
      </section>
      <section className="pb-24">
        <div className="mx-auto max-w-4xl px-5 lg:px-8">
          {sections.map((s, i) => (
            <Reveal key={i} delay={Math.min(i * 0.04, 0.3)}>
              <div className="grid gap-2 border-t border-[#E2DDD5] py-8 sm:grid-cols-12 sm:gap-8" data-testid={`${kind}-section-${i}`}>
                <span className="font-mono text-sm font-semibold text-[#B8860B] sm:col-span-2">{String(i + 1).padStart(2, "0")}</span>
                <h2 className="font-syne text-lg font-semibold text-[#0F1B2B] sm:col-span-4">{s.heading}</h2>
                <p className="text-sm leading-relaxed text-[#5A6578] sm:col-span-6">{s.body}</p>
              </div>
            </Reveal>
          ))}
          <p className="mt-8 border-t border-[#E2DDD5] pt-8 font-mono text-xs text-[#8896AB]">
            Last updated: {new Date().toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })}
          </p>
        </div>
      </section>
      <Footer brand={content.brand} contact={content.contact} social={content.social} footer={content.footer} />
    </div>
  );
}
